/**
 * number()
 * @returns {string}
 */
const number = () => {
  return window.crypto.getRandomValues(new Uint32Array(1))[0]
    .toString(16)
    .substring(0, 4);
};

/**
 * character()
 * @param length
 * @returns {string}
 */
const character = length => {
  let text = '';
  const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';

  for (let i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }

  return text;
};

/**
 * Guid
 */
export class Guid {

  static NEW() {
    return (number() + number() + '-' + number() + '-' + number() + '-' + number() + '-' + number() + number() + number());
  }

  static CHAR(length = 8) {
    return (character(length));
  }
}